/**
 * Sort items by friendlyId using locale-aware string comparison
 */
export function sortByFriendlyId<T extends { friendlyId?: string | null }>(
  a: T,
  b: T,
): number {
  const aFriendlyId = a.friendlyId || '';
  const bFriendlyId = b.friendlyId || '';
  return aFriendlyId.localeCompare(bFriendlyId);
}
